import script from "./contactusView.vue?vue&type=script&setup=true&lang=js"
export * from "./contactusView.vue?vue&type=script&setup=true&lang=js"

import "./contactusView.vue?vue&type=style&index=0&id=c6a33816&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6a33816"]])

export default __exports__